import React from "react";
import { Box, Container, CssBaseline } from "@mui/material";
import Header from "./Header";
import { useAuth } from "../../contexts/AuthContext";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { logout } = useAuth();

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <Header onLogout={logout} />
        <Container component="main" maxWidth="xl" sx={{ flexGrow: 1, py: 3 }}>
          {children}
        </Container>
      </Box>
    </>
  );
};

export default Layout;
